/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetChallengeChallengeId200Response
 */
export interface GetChallengeChallengeId200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetChallengeChallengeId200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetChallengeChallengeId200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeId200Response
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeId200Response interface.
 */
export function instanceOfGetChallengeChallengeId200Response(value: object): value is GetChallengeChallengeId200Response {
    return true;
}

export function GetChallengeChallengeId200ResponseFromJSON(json: any): GetChallengeChallengeId200Response {
    return GetChallengeChallengeId200ResponseFromJSONTyped(json, false);
}

export function GetChallengeChallengeId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function GetChallengeChallengeId200ResponseToJSON(json: any): GetChallengeChallengeId200Response {
    return GetChallengeChallengeId200ResponseToJSONTyped(json, false);
}

export function GetChallengeChallengeId200ResponseToJSONTyped(value?: GetChallengeChallengeId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

